// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchStationsView {
  position: relative;
  height: 100vh;
}`, "",{"version":3,"sources":["webpack://./src/Views/AfterAuth/SearchStationsView/SearchStationView.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,aAAA;AACJ","sourcesContent":[".SearchStationsView {\n    position: relative;\n    height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
